/** Column definition for app-form-table — optional flags control presentation only. */
export interface FormTableHeaderColumn {
  key: string;
  label: string;
  /** When true, cell text is shown with Angular's uppercase pipe after formatting. */
  uppercase?: boolean;
}

/** Standard tracking / form number column (display uppercase in tables). */
export const FORM_NUMBER_TRACKING_HEADER: FormTableHeaderColumn = {
  key: 'tracking_id_display',
  label: 'Form Number',
  uppercase: true,
};
